import { gql, DocumentNode } from '@apollo/client';

import { LoginInput } from '../../types/Auth';

export interface SignInMutationVariables {
  input: LoginInput;
}

export interface SignInMutationResult<TUser> {
  user: TUser;
}

export const signInMutation = (UserFragment: DocumentNode) => gql`
  mutation SignInMutation($input: SignInMutationInput!) {
    user(input: $input) @rest(type: "User", path: "auth/signin", method: "POST") {
      ...User
    }
  }
  ${UserFragment}
`;
